import { trpc } from "../trpc";

export function useDeleteTemplate() {
  const utils = trpc.useUtils();

  return trpc.template.delete.useMutation({
    onSuccess(_, variables) {
      utils.template.search.invalidate();
      utils.template.get.invalidate({ id: variables.id });
    },
  });
}
